<template>
	<productHome v-if="projectName == 'WGQ'"></productHome>
	<LQHomePage v-else></LQHomePage>
</template>

<script>
import productHome from './productHome/productHome.vue';
// import projectHome from './projectHome/projectHome.vue';
import LQHomePage from '../LQHomepage/index.vue'
import config from '../../../../configHttp';
export default {
	components: { productHome, LQHomePage },
	data() {
		return { projectName: '' };
	},
	created() {
		this.projectName = config.projectName;
	},
	methods: {
	}
};
</script>

<style scoped="scoped" lang="less"></style>
